import { useTranslation } from 'react-i18next';
import { Section, Container, SectionTitle } from '../../ui';
import styles from './RepriseProcess.module.css';

interface Step {
  title: string;
  text: string;
}

export function RepriseProcess() {
  const { t } = useTranslation('reprise');
  const raw = t('process.steps', { returnObjects: true });
  const steps: Step[] = Array.isArray(raw) ? (raw as Step[]) : [];

  return (
    <Section variant="gray" id="methode">
      <Container>
        <SectionTitle title={t('process.title')} subtitle={t('process.subtitle')} centered />
        <ol className={styles.steps}>
          {steps.map((step, index) => (
            <li key={step.title} className={styles.step}>
              <span className={styles.stepNumber}>{String(index + 1).padStart(2, '0')}</span>
              <div className={styles.stepBody}>
                <h3 className={styles.stepTitle}>{step.title}</h3>
                <p className={styles.stepText}>{step.text}</p>
              </div>
            </li>
          ))}
        </ol>
      </Container>
    </Section>
  );
}
